import React, { FC } from "react";
import StartRating from "components/StartRating/StartRating";
import { Link } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import SaleOffBadge from "components/SaleOffBadge/SaleOffBadge";
import Badge from "shared/Badge/Badge";
import NcImage from "shared/NcImage/NcImage";
import { ManyItem } from "types/interfaces";
import { RootState } from "store";
import { useSelector } from "react-redux";
import formatRupiah from "utils/toRupiah";

export interface CarCardHProps {
  loading?: boolean;
  className?: string;
  data?: ManyItem;
}

const CarCardH: FC<CarCardHProps> = ({
  loading = false,
  className = "",
  data = {} as ManyItem,
}) => {
  const { likedProducts } = useSelector(
    (state: RootState) => state.likedProduct
  );

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full flex items-center justify-center md:w-72 flex-shrink-0 border-r border-neutral-100 dark:border-neutral-800">
        <div className="w-full py-5 sm:py-0">
          {loading ? (
            <div className="bg-gray-400 animate-pulse"></div>
          ) : (
            <NcImage
              className="w-full"
              src={data.thumbnail ?? data.images[0]}
            />
          )}
        </div>
        <BtnLikeIcon
          isLiked={
            likedProducts &&
            likedProducts.find((value: string) => {
              return value === data._id;
            })
              ? true
              : false
          }
          className="absolute right-3 top-3"
        />
        {!!data.status?.saleOff && (
          <SaleOffBadge className="absolute left-3 top-3" />
        )}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className="flex-grow p-3 sm:p-5 flex flex-col">
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            {data.status?.isAds && <Badge name="ADS" color="green" />}
            {loading ? (
              <div className="bg-gray-400 animate-pulse w-32 h-8 rounded-md"></div>
            ) : (
              <h2 className="text-xl font-semibold capitalize">
                <span className="line-clamp-1">{data.name}</span>
              </h2>
            )}
          </div>
          <div className="flex items-center space-x-4 text-sm text-neutral-500 dark:text-neutral-400">
            <StartRating
              reviewCount={data.status?.reviews?.length}
              point={data.status?.rating}
            />
            <span>· </span>
            <div className="flex items-center">
              <span className="hidden sm:inline-block  text-base">
                <i className="las la-map-marked"></i>
              </span>
              <span className="sm:ml-2 line-clamp-1">
                {" "}
                {data.address?.kecamatan?.name}
              </span>
            </div>
          </div>
        </div>
        <div className="hidden sm:block w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>
        {/* SHOW MOBILE */}
        <div className="flex sm:hidden items-center text-sm text-neutral-500 dark:text-neutral-400 space-x-2 mt-4 sm:mt-0">
          <span>4 seats</span>
          <span>· </span>
          <span>Auto gearbox</span>
          <span>· </span>
          <span>4 seats</span>
        </div>
        {/* SHOW DESK */}
        {/* <div className="hidden sm:flex items-center space-x-8">
          <div className="flex items-center space-x-2">
            <i className="las la-user-friends text-xl"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              4 seats
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="las la-dharmachakra text-xl"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              Auto gearbox
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="las la-suitcase text-xl"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              2 bags
            </span>
          </div>
        </div> */}

        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>
        <div className="flex justify-between items-end">
          {/* <div className="flex items-center space-x-3 text-sm text-neutral-700  dark:text-neutral-300">
            <Avatar imgUrl={author.avatar} userName={author.displayName} />
            <span className="hidden sm:inline-block">
              <span className="hidden sm:inline">Pemilik </span>{" "}
              {author.displayName}
            </span>
          </div> */}
          <span className="text-lg flex justify-center items-center font-semibold text-neutral-700 dark:text-neutral-200">
            {loading ? (
              <div className="bg-gray-400 animate-pulse w-32 h-6 rounded-md"></div>
            ) : (
              <span>{formatRupiah(data.price || 0, { prefix: "Rp. " })}</span>
            )}
            {` `}
            <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
              / hari
            </span>
          </span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-CarCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="CarCardH"
    >
      <Link to={`/listing/${data._id}`} className="flex flex-col md:flex-row">
        {renderSliderGallery()}
        {renderContent()}
      </Link>
    </div>
  );
};

export default CarCardH;
